export interface PresentationAudio {
  currentTime: number;
  volume: number;
  play(): Promise<void> | void;
  pause(): void;
}

export type PresentationAudioFactory = (source: string) => PresentationAudio;

export const createPresentationAudio: PresentationAudioFactory = (source) => new Audio(source);
